export const getTrash = trash => ({
    type: 'GET_TRASH',
    trash
  })